import { useCallback, useRef } from "react";

// Scroll-snap carousel: arrows move one "page" of visible cards, wrapping at the ends.
export function useScrollCarousel<T extends HTMLElement>() {
  const trackRef = useRef<T>(null);

  const scroll = useCallback((direction: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    const maxScroll = track.scrollWidth - track.clientWidth;
    if (direction === 1 && track.scrollLeft >= maxScroll - 4) {
      track.scrollTo({ left: 0, behavior: "smooth" });
      return;
    }
    if (direction === -1 && track.scrollLeft <= 4) {
      track.scrollTo({ left: maxScroll, behavior: "smooth" });
      return;
    }
    track.scrollBy({ left: direction * track.clientWidth, behavior: "smooth" });
  }, []);

  return { trackRef, prev: () => scroll(-1), next: () => scroll(1) };
}
